import { Department } from "@/types";
import { Brain, Dna } from "lucide-react";
import { SiSpine } from 'react-icons/si';
import { FaHeartbeat } from 'react-icons/fa';
import { BsLungs } from 'react-icons/bs';
import { GiKidneys, GiStomach } from 'react-icons/gi';

const departmentsAndDiseases: Department[] = [
  {
    id: 1,
    slug: "nervous",
    diseases: ['facial-neuritis', 'neuropathy', 'tics', 'neuralgia', 'neurosis', 'headaches', 'insomnia', 'vegetative-dysfunctions', 'depression', 'anxiety'],
    icon: <Brain className="h-10 w-10" />
  },
  {
    id: 2,
    slug: "musculoskeletal",
    diseases: ['osteochondrosis', 'disc-herniations', 'tendinitis', 'radiculitis', 'sciatica', 'rehabilitation-after-trauma', 'arthrosis', 'osteoarthrosis', 'myalgia', 'arthritis', 'gout'],
    icon: <SiSpine className="h-10 w-10" />
  },
  {
    id: 3,
    slug: "cardiovascular",
    diseases: ['high-pressure', 'ischemic-disease', 'circulation-disorders'],
    icon: <FaHeartbeat className="h-10 w-10" />
  },
  {
    id: 4,
    slug: "respiratory",
    diseases: ['sinusitis', 'bronchitis', 'pulmonary-disease', 'bronchial-asthma', 'pneumonia'],
    icon: <BsLungs className="h-10 w-10" />
  },
  {
    id: 5,
    slug: "digestive",
    diseases: ['gastritis', 'duodenal-ulcer', 'cholecystitis', 'pancreatitis', 'biliary-dyskinesia', 'bowel-syndrome', 'intestinal-transit-disorders'],
    icon: <GiStomach className="h-10 w-10" />
  },
  {
    id: 6,
    slug: "urogenital",
    diseases: ['kidney-diseases', 'pelvic-organ-prolapse', 'dysmenorrhea', 'amenorrhea', 'menstrual-bleeding', 'severe-premenstrual-syndrome', 'algodysmenorrhea', 'infertility', 'impotence', 'prostatitis'],
    icon: <GiKidneys className="h-10 w-10" />
  },
  {
    id: 7,
    slug: "endocrine",
    diseases: ['diabetes', 'hypothyroidism', 'hyperthyroidism', 'thyroid-neck'],
    icon: <Dna className="h-10 w-10" />
  }
];

export default departmentsAndDiseases;
